<template>
   <div class="room-card-wrapper" :style="dynamicCssVariable" :class="[isSelectedItem ? 'active' : 'deactive', !isVisible ? 'd-none' : '']">
      <div class="room-card-inner" :class="{ 'hide-provider-tooltip': isOnUsContract && isOnUs }">
         <div class="room-card-inner-item room-card-content">
            <div class="room-card-content-item room-card-image" v-if="room.isImageExist && isOnUsContract">
               <img class="with-image" :src="room.images[0].small" alt="" />
            </div>
            <div :class="room.isImageExist ? 'room-card-content-item room-card-name' : 'room-card-content-item room-card-name-no-image'">
               <div class="partial-payment" v-if="roomDetail.hasPartialPayment">
                  <div class="partial-payment-icon-container">
                     <div id="partial-payment-icon" class="gts-icon icon-partial-payment"></div>
                  </div>
                  <div class="partial-payment-text">
                     <span>{{ $t("hotelCard_lblPartialPayment") }}</span>
                  </div>
               </div>
               <div class="gts-flag" :class="isOnUsContract && isOnUs ? 'visible' : 'invisible'"></div>
               <!-- <div class="provider-badge" v-if="isOnUsContract && !isOnUs">Provider</div> -->
               <div class="refund-badge-wrapper" :class="isOnUsContract ? '--onUs' : ''" v-if="isRefundTypeBadgeVisible">
                  <UIInfoBadge
                     :className="'EHtlRefundType'"
                     :modifier="room.refundType == 1 ? '--refundable' : room.refundType == 2 ? '--nonrefundable' : ''"
                     :text="`${$options.filters.EHtlRefundType(room.refundType)}`" />
               </div>
               <div id="room-card-info">
                  <h4 class="room-name-title">{{ room.name }}</h4>
                  <p class="room-board-type">{{ room.board }}</p>
                  <UIButton
                     v-if="isOnUsContract && room.isImageExist"
                     style="background: transparent; color: #175899; font-size: 14px; width: 130px; text-decoration: underline; margin-left: 0.25rem; font-weight: 600"
                     @click.native="handlergetRoomDetail(room, roomGroupIndex)"
                     :text="$t('hotelRoomCard_lblDetailSeeDetails')">
                  </UIButton>
                  <UIButton
                     v-else
                     style="background: transparent; color: #175899; font-size: 14px; width: 130px; text-decoration: underline; font-weight: 600; margin-left: 0.25rem; visibility: hidden"
                     @click.native="handlergetRoomDetail(room, roomGroupIndex)"
                     :text="$t('hotelRoomCard_lblDetailSeeDetails')" />
               </div>
            </div>

            <template v-if="room.price.restrictionType != 1">
               <div class="room-card-content-item take-me-to-search">
                  <div class="Available-calendar" @click="showAvailableCalendar" v-if="AvailableCalendarIsVisible">
                     <UIMultiDatePicker @close="closeAvailableCalendar" :hotelId="calenderHotelId" :isRecommendedRoom="isRecommendedRoom" :roomDetail="room"></UIMultiDatePicker>
                  </div>

                  <button @click="showAvailableCalendar" :class="AvailableCalendarIsVisible ? 'isClicked' : ''">
                     <i class="gts-icon icon-datepicker-room-card"></i>
                     {{ $t("hotelCard_lblChangeDate") }}
                  </button>
                  <span class="restrictions-info-txt">
                     {{ handlerRestrictionsFMT(room.price.restrictionValue, room.price.restrictionType) }}
                  </span>
               </div>
               <div class="room-card-content-item room-card-price" v-if="room.price.total !== 0">
                  <span>{{ $t("roomCard_lblRoomPrice") }}</span>
                  <span class="room-price discount" v-if="room.price.originalAmount > room.price.total">
                     {{ room.price.originalAmount | price(room.price.currency) }}
                  </span>
                  <span class="room-price" :class="room.price.originalAmount > room.price.total ? 'discounted' : ''">
                     {{ room.price.total | price(room.price.currency) }}
                  </span>
               </div>
            </template>

            <template v-else>
               <div class="room-card-content-item room-card-price">
                  <AddonPopover v-if="room.addOns.length > 0" :addonInformations="{ addOnCurrency: room.addOnCurrency, addOnTotal: room.addOnTotal, addOns: room.addOns }" />
                  <span>{{ $t("roomCard_lblRoomPrice") }}</span>
                  <span class="room-price discount" v-if="room.price.originalAmount > room.price.total">
                     {{ room.price.originalAmount | price(room.price.currency) }}
                  </span>
                  <span class="room-price" :class="room.price.originalAmount > room.price.total ? 'discounted' : ''">
                     {{ room.price.total | price(room.price.currency) }}
                  </span>
               </div>
               <div class="room-card-content-item room-card-pax-cta" :class="isSelectedItem ? 'selected-item' : null">
                  <i class="gts-icon icon-add-leg" @click="handlerSelectRoom(room, roomGroupIndex)" v-if="!isSelectedItem"></i>
                  <i class="gts-icon icon-error" @click="handlerDeleteRoom(room, roomGroupIndex)" v-else></i>
                  <!-- <UIButton className="default" icon="add-leg" rounded="true" @click.native="handlerSelectRoom(room, roomGroupIndex)" v-if="!isSelectedItem" /> -->
                  <!-- <UIButton className="default" icon="error" rounded="true" @click.native="handlerDeleteRoom(room, roomGroupIndex)" v-else /> -->
               </div>
            </template>

            <!-- <template v-if="room.price.restrictionType != 1 || 1 == 0"> -->
            <template v-if="false">
               <div class="room-card-content-item room-restrictions">
                  <i></i>
                  <span class="restrictions-info-txt">
                     <!-- {{ room.price.restrictionType | EHtlPriceRestrictionType }}
                     {{ room.price.restrictionValue }} -->

                     {{ handlerRestrictionsFMT(room.price.restrictionValue, room.price.restrictionType) }}
                  </span>
               </div>
            </template>
            <!-- -->
         </div>
      </div>

      <UIModal size="md" :title="`${room.name} (${room.board})`" ref="uiModal" v-if="room.description">
         <div class="room-detail-section room-slider">
            <GtsRoomSlider :sliderImages="room.images" />
         </div>
         <div class="room-detail-section room-description">
            <div class="section-title">
               <h4>oda açıklamaları</h4>
            </div>
            <div class="section-content">
               <p>{{ room.description }}</p>
            </div>
         </div>
         <!-- <div class="room-detail-section room-facilities">
                <div class="section-title">
                    <h4>oda imkanları</h4>
                </div>
                <div class="section-content">
                    <div class="room-facilities-list">
                        <div class="room-facilities-list-item">
                            <i class="gts-icon icon-facility-bar"></i>
                            <span>{{ facility.name }}</span>
                        </div>
                    </div>
                </div>
            </div> -->
         <template #footer>
            <div class="customer-book-form-cta">
               <UIButton className="default_outline" :text="$t('common_close')" @click.native="handlerShowRoomDetailModal()" />
            </div>
         </template>
      </UIModal>
      <UIModalDetail :modalSize="'large'" v-show="showDetailModal" :noBorder="true" :hasSlot="true" :noCloseIcon="false" @close-modal="showDetailModal = false">
         <div class="detail-modal-wrapper">
            <div class="detail-modal-wrapper modal-header">
               <div>
                  <span>{{ room.name }}</span>
                  <p>{{ room.board }}</p>
               </div>
               <div class="partial-payment" v-if="roomDetail.hasPartialPayment">
                  <div class="partial-payment-icon-container">
                     <div id="partial-payment-icon" class="gts-icon icon-partial-payment"></div>
                  </div>
                  <div class="partial-payment-text">
                     <span>{{ $t("hotelCard_lblPartialPayment") }}</span>
                  </div>
               </div>
               <div class="gts-flag" :class="isOnUsContract ? 'visible' : 'invisible'"></div>
            </div>

            <div class="detail-modal-wrapper modal-hotel-room-image">
               <div class="hotel-image-slide-box left-arrow" @click="previousImage()">
                  <i class="gts-icon icon-arrow-left icon-sm"></i>
               </div>
               <img :src="roomImages[RoomImageselectedIndex].img" />
               <div class="hotel-image-slide-box right-arrow" @click="nextImage()">
                  <i class="gts-icon icon-arrow-right icon-sm"></i>
               </div>
            </div>
            <div class="detail-modal-wrapper modal-hotel-mini-images">
               <img :src="value.img" v-for="(value, index) in roomImages" :key="index" :class="value.activeStatus ? 'active-image' : ''" @click="SelectMiniImage(index)" />
            </div>
            <div class="detail-modal-wrapper room-informations" v-if="roomDetailSearch.description != null">
               <span>{{ $t("hotelRoomCard_lblDetailRoomInformations") }}</span>
               <p>
                  {{ roomDetailSearch.description }}
               </p>
            </div>

            <div class="detail-modal-wrapper room-informations-features" v-if="roomDetailSearch.topFacilities != null">
               <span>{{ $t("hotelRoomCard_lblDetailHighlightedFeatures") }}</span>
               <div class="facility-highligted">
                  <span v-for="(topFacilities, key, index) in roomDetailSearch.topFacilities" :key="index"
                     ><img :src="`${$constants.cdn}/hotel_facility/${key}.svg`" alt="" @error="$event.target.src = `${$constants.cdn}/hotel_facility/no_icon.svg`" />{{ topFacilities }}</span
                  >
               </div>
            </div>
            <div class="detail-modal-wrapper room-features" v-if="roomDetailSearch.facilities != 0">
               <span>{{ $t("hotelRoomCard_lblDetailRoomFeatures") }}</span>
               <div class="facilites">
                  <div class="room-facilites" v-for="(facilites, key, index) in roomDetailSearch.facilities" :key="index">
                     <div class="facility-header">
                        <img id="FacitiyImageId" :src="`${$constants.cdn}/hotel_facility/${facilites.id}.svg`" alt="" @error="$event.target.src = `${$constants.cdn}/hotel_facility/no_icon.svg`" />
                        <span>{{ facilites.name }}</span>
                     </div>
                     <div class="facility-details" v-for="(facilitesContent, key, index) in facilites.facilities" :key="index">
                        <p>- {{ facilitesContent.name }}</p>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Add On Horizontal Display -->
            <AddonHorizontalView v-if="room.addOns.length > 0" :addonInformations="{ addOnCurrency: room.addOnCurrency, addOnTotal: room.addOnTotal, addOns: room.addOns }" />

            <div class="detail-modal-wrapper room-options" v-if="!isTempOption">
               <span>{{ $t("hotelRoomCard_lblDetailRoomOptions") }}</span>
               <div v-if="room.refundType == 2">
                  <div class="room-options-radio" v-for="(item, index) in roomDetailSearch.roomOptions" :key="index">
                     <div class="ref-nonref-radio">
                        <UIRadioButton :label="handlerRefundTypeLabel(item)" v-model="roomDetailRadioNativeValue" :nativeValue="setDetailModalValue(item.refundType)" />
                     </div>
                  </div>
               </div>
               <div class="add-on-price-room-detail-wrapper" v-if="room.addOns.length > 0">
                  <span class="add-on-label">{{ $t("hotelBasket_lblAddOnPrice") }}</span>
                  <span class="add-on-price">{{ $options.filters.price(room.addOnTotal, room.addOnCurrency) }}</span>
               </div>
               <div class="room-detail-price">
                  <!-- discount var ise  -->
                  <span class="room-detail-total">{{ $t("basketComponentFlight_total") }}</span>
                  <div class="room-discounted-price" v-if="room.price.originalAmount > room.price.total">
                     {{ discountedRoomPrice | price(room.price.currency) }}
                  </div>

                  <div class="room-price">{{ (room.price.total + detailRoomPrice) | price(room.price.currency) }}</div>
               </div>
            </div>
            <div class="detail-modal-wrapper buttons">
               <div class="inner-buttons">
                  <UIButton :className="'grayscale'" text="Close" :notRounded="true" @click.native="showDetailModal = false" />
               </div>
               <UIButton
                  :className="'default'"
                  text="Reserve"
                  :notRounded="true"
                  @click.native="
                     roomDetailRadioNativeValue == 2
                        ? (handlerSelectRoom(room, roomGroupIndex), (showDetailModal = false))
                        : (handlerSelectRoom(roomDetailSearch.roomOptions[0], roomGroupIndex), (showDetailModal = false))
                  " />
            </div>
         </div>
      </UIModalDetail>
      <RoomCardDebugger :infos="infos" v-if="isDebugger" />
      <RoomCardDebuggerDetailed :infos="infosDetailed" v-if="isDebuggerDetaild" />
   </div>
</template>

<script>
import UIRadioButton from "@/components/unitary/form2/UIRadioButton.vue";
import { hotelService } from "@/service/index.js";
import UIButton from "@/components/unitary/Button.vue";
import UIModal from "@/components/utils/Modal.vue";
import UIInfoBadge from "@/components/unitary/InfoBadge.vue";
import GtsRoomSlider from "@/components/utils/GtsRoomSlider.vue";
import RoomCardDebugger from "./RoomCardDebugger.vue";
import RoomCardDebuggerDetailed from "./RoomCardDebuggerDetailed.vue";
import Popup from "@/gts-popup.js";
import { listify } from "@/helper/common";

import defaultImageThumbnail from "@/assets/images/hotelPlaceholder.jpg";
import UIModalDetail from "@/components/unitary/form2/UIModal.vue";
import UIMultiDatePicker from "@/components/unitary/form2/UIMultiDatePicker.vue";
import AddonPopover from "@/components/structural/hotel/search/AddonPopover.vue";
import AddonHorizontalView from "./AddonHorizontalView.vue";
export default {
   name: "RoomCardComponent",
   components: {
      UIModalDetail,
      UIButton,
      UIModal,
      UIRadioButton,
      UIInfoBadge,
      GtsRoomSlider,
      RoomCardDebugger,
      RoomCardDebuggerDetailed,
      UIMultiDatePicker,
      AddonPopover,
      AddonHorizontalView,
   },
   props: {
      roomDetail: { type: Object },
      hotelId: { type: Number },
      roomItemCode: { type: String },
      isDynamicPackage: { type: Boolean },
      roomGroupIndex: { String },
      isRecommendedHotelRoom: { type: Boolean },
      channels: { type: Object },
      hotelName: String,
      handlerClickedRoomIndex: { type: Function },
   },
   data() {
      return {
         calenderHotelId: this.hotelId,
         isRecommendedRoom: this.isRecommendedHotelRoom,
         discountedRoomPrice: this.roomDetail.price.originalAmount,
         RoomImageselectedIndex: 0,
         roomImages: [{}],
         roomDetailRadioValueNonRefundable: 2,
         roomDetailRadioValueRefundable: 1,
         roomDetailRadioNativeValue: 2,
         detailRoomPrice: 0,
         showDetailModal: false,
         room: this.roomDetail,
         roomCode: this.roomItemCode,
         selectedRooms: [],
         roomTypeFilter: [],
         basketResponse: "",
         dynamicPackage: false,
         defaultImageThumbnail: defaultImageThumbnail,
         isOnUsContract: false,
         isOnUs: false,
         isSelectedItem: false,
         isVisible: true,
         isDebugger: false,
         isDebuggerDetaild: false,
         infos: null,
         infosDetailed: [],
         roomDetailSearch: {},
         priceDiff: 0,
         isTempOption: false,
         AvailableCalendarIsVisible: false,
      };
   },
   created() {
      const self = this;
      self.isOnUsContract = this.$parent._data.hotel.channels[self.room.channelId].onUsContract;
      self.isOnUs = this.$parent._data.hotel.channels[self.room.channelId].onUs;
      self.infos = {
         searchUid: this.$store.state.hotel.searchUuid,
         roomIdentifier: self.roomDetail.roomIdentifier,
         channelManagerName: self.roomDetail.channelManagerName,
         channelName: `channel_name: ${self.channels[self.roomDetail.channelId].channelName} - id: ${self.roomDetail.channelId}`,
         providerName: `provider_name: ${self.channels[self.roomDetail.channelId].providerName} - id: ${self.channels[self.roomDetail.channelId].providerId}`,
         spoIds: self.roomDetail.spoIds.length != 0 ? `spoIds: ${self.roomDetail.spoIds}` : null,
         restrictionType: `restriction_type: ${this.$options.filters.EHtlPriceRestrictionType(self.roomDetail.price.restrictionType)}`,
      };

      for (let i = 0; i < self.roomDetail.cancellationPolicies.length; i++) {
         self.infosDetailed.push({
            searchUid: this.$store.state.hotel.searchUuid,
            fromDate: `fromDate: ${self.roomDetail.cancellationPolicies[i].fromDate}`,
            toDate: `toDate: ${self.roomDetail.cancellationPolicies[i].toDate}`,
            policyType: `policy_Type: ${this.$options.filters.EHtlPolicyType(self.roomDetail.cancellationPolicies[i].policyType)}`,
            value: `amount: ${self.roomDetail.cancellationPolicies[i].value} ${self.roomDetail.cancellationPolicies[i].amountType == 1 ? "%" : self.roomDetail.cancellationPolicies[i].currency}`,
            amountType: `amount_Type: ${this.$options.filters.EHtlAmountType(self.roomDetail.cancellationPolicies[i].amountType)}`,
            currency: `currency: ${self.roomDetail.cancellationPolicies[i].currency}`,
         });
      }

      document.body.addEventListener("keydown", (event) => {
         let held = false;

         if (event.ctrlKey && event.altKey) {
            held = true;
         }

         if (held && event.keyCode == 73) {
            self.isDebugger = !self.isDebugger;
         }
      });
      document.body.addEventListener("keydown", (event) => {
         let held = false;

         if (event.ctrlKey && event.altKey) {
            held = true;
         }

         if (held && event.keyCode == 80) {
            self.isDebuggerDetaild = !self.isDebuggerDetaild;
         }
      });
   },
   mounted() {
      // Dışarı tıklama olayını dinlemek için event listener eklenmesi
      document.addEventListener("click", this.handleOutsideClick);
   },
   beforeDestroy() {
      // Component yok edilmeden önce event listener'ı kaldırmak için
      document.removeEventListener("click", this.handleOutsideClick);
   },
   methods: {
      handlerRefundTypeLabel(item) {
         switch (item.refundType) {
            case 1:
               return `${
                  this.$options.filters.EHtlRefundType(item.refundType) +
                  " (" +
                  (item.price.total > this.room.price.total ? "+" : "") +
                  this.priceDiff.toFixed(2) +
                  "" +
                  this.$options.filters.price(this.room.price.currency) +
                  ")"
               }`;
            case 2:
               return this.$options.filters.EHtlRefundType(item.refundType);
         }
      },
      setDetailModalValue(refundType) {
         if (refundType == 2) {
            return this.roomDetailRadioValueNonRefundable;
         } else if (refundType == 1) {
            return this.roomDetailRadioValueRefundable;
         }
      },
      handleOutsideClick(event) {
         if (!this.$el.contains(event.target)) {
            if (event.target.id === "next") {
               return; // Eğer event.target'ın id'si "next" ise fonksiyonu burada sonlandır
            }
            if (event.target.id === "prev") {
               return; // Eğer event.target'ın id'si "prev" ise fonksiyonu burada sonlandır
            }

            setTimeout(() => {
               this.AvailableCalendarIsVisible = false;
            }, 200); // 200 milisaniye gecikme ekleyerek debouncing sağlanıyor
         }
      },

      showAvailableCalendar() {
         this.AvailableCalendarIsVisible = true;
      },
      closeAvailableCalendar() {
         this.AvailableCalendarIsVisible = false;
      },
      previousImage() {
         const imageLength = this.roomImages.length;
         this.resetMiniImagesStatus();
         if (this.RoomImageselectedIndex == 0) {
            this.RoomImageselectedIndex = imageLength - 1;
            this.roomImages[this.RoomImageselectedIndex].activeStatus = true;
         } else {
            this.RoomImageselectedIndex--;
            this.roomImages[this.RoomImageselectedIndex].activeStatus = true;
         }
      },
      nextImage() {
         this.resetMiniImagesStatus();
         const imageLength = this.roomImages.length;
         if (this.RoomImageselectedIndex == imageLength - 1) {
            this.RoomImageselectedIndex = 0;
            this.roomImages[this.RoomImageselectedIndex].activeStatus = true;
         } else if (this.RoomImageselectedIndex >= 0) {
            this.RoomImageselectedIndex++;
            this.roomImages[this.RoomImageselectedIndex].activeStatus = true;
         }
      },
      resetMiniImagesStatus() {
         for (var i = 0; i < this.roomImages.length; i++) {
            this.roomImages[i].activeStatus = false;
         }
      },
      SelectMiniImage(index) {
         this.resetMiniImagesStatus();
         this.RoomImageselectedIndex = index;
         this.roomImages[index].activeStatus = true;
      },
      showDetailModalFunc() {
         this.showDetailModal = true;
         const roomImagesActive = this.roomImages.map((image) => ({
            img: image.large,
            activeStatus: false,
         }));
         roomImagesActive[0].activeStatus = true;
         this.roomImages = roomImagesActive;
      },
      handlerGoToSearch() {
         window.scrollTo(0, 0);
         this.$store.state.hotel.datePickerStatus = true;
      },
      handlerRestrictionsFMT(val, type) {
         const typeEnum = this.$options.filters.EHtlPriceRestrictionType(type);
         const willReturn = this.$t(`hotelRoomCard_lbl${typeEnum}`).replace("#VALUE#", val);

         return willReturn;
      },
      handlergetRoomDetail(roomItem, roomGroupIndex) {
         this.$store.commit("app/setIsProgressGifActive", true);
         var query = {
            roomIdentifier: roomItem.roomIdentifier,
            searchUuid: this.$store.state.hotel.searchUuid,
            recommended: this.isRecommendedHotelRoom,
            hotelId: this.hotelId,
            roomGroup: roomGroupIndex,
         };
         hotelService.hotelRoomDetail(query).then((response) => {
            this.$store.commit("app/setIsProgressGifActive", false);
            if (!response.result.success) {
               Popup.result(response.result);
               return;
            } else {
               this.roomDetailSearch = response;
               this.roomImages = response.images;
               if (this.roomDetailSearch.roomOptions.length == 0) {
                  this.isTempOption = true;
                  const tempRoomPrice = [
                     {
                        nonRefundable: false,
                        refundType: 1,
                        isSelected: false,
                        roomIdentifier: "100_77854_1851_979_29224_1_R_0",
                        price: {
                           channelId: 100,
                           specialOffer: false,
                           roomName: null,
                           boardCode: "1",
                           boardName: "Yarım Pansiyon",
                           agencyCommission: 2.54,
                           agencyCommissionRatio: 0.1,
                           agencyCommissionExtra: 0,
                           originalAmount: 25.43,
                           total: 25.43,
                           grandTotal: 25.43,
                           currency: "EUR",
                           restrictionType: 1,
                           restrictionValue: 0,
                        },
                     },
                  ];
                  this.roomDetailSearch.roomOptions = tempRoomPrice;
               }

               // if (this.roomDetailSearch.roomOptions[0].price.total > this.room.price.total) {
               //    this.priceDiff = this.roomDetailSearch.roomOptions[0].price.total - this.room.price.total;
               // } else {
               //    this.priceDiff = this.room.price.total - this.roomDetailSearch.roomOptions[0].price.total;
               // }
               this.priceDiff = this.roomDetailSearch.roomOptions[0].price.total - this.room.price.total;

               this.showDetailModalFunc();
            }
         });
      },
      handlerDeleteRoom(roomItem, roomGroupIndex) {
         const self = this;
         self.$store.commit("app/setIsProgressGifActive", true);

         if (self.isDynamicPackage) {
            this.$store.state.hotel.selectedRooms = {};
         } else {
            if (this.$store.state.hotel.selectedRooms[roomGroupIndex] == roomItem.roomIdentifier) {
               delete this.$store.state.hotel.selectedRooms[roomGroupIndex];
            }
         }

         var query = {
            searchUuid: this.$store.state.hotel.searchUuid,
            hotelId: this.hotelId,
            rooms: this.$store.state.hotel.selectedRooms,
            recommended: this.isRecommendedHotelRoom,
         };

         hotelService.hotelSelect(query).then((response) => {
            if (!response.result.success) {
               Popup.result(response.result);
               return;
            } else {
               self.basketResponse = {
                  hotelCode: Object.keys(response.rooms).length === 0 ? 0 : response.hotelId,
                  id: response.id,
                  rooms: response.rooms,
                  totalPrice: response.totalPrice.total,
                  totalPriceCurrency: this.$options.filters.currency(response.totalPrice.currency),
                  uuid: response.uuid,
                  checkoutEnabled: response.checkoutEnabled,
                  recommended: response.recommended,
                  roomGroupCode: response.roomGroupCode,
                  channelId: Object.keys(response.rooms).length === 0 ? 0 : response.channelId,
                  boardId: Object.keys(response.rooms).length === 0 ? 0 : response.boardId,
                  hotelName: Object.keys(response.rooms).length === 0 ? 0 : response.hotelName,
                  boardName: Object.keys(response.rooms).length === 0 ? 0 : response.board,
                  hotelStar: Object.keys(response.rooms).length === 0 ? 0 : response.hotelStar,
               };
               self.$store.commit("app/setIsProgressGifActive", false);
               this.$store.commit("hotel/updateBasketResponse", self.basketResponse);
            }
         });
      },
      handlerSelectRoom(roomItem, roomGroupIndex) {
         var self = this;
         self.$store.commit("app/setIsProgressGifActive", true);

         this.$store.state.hotel.selectedRooms[`${roomGroupIndex}`] = roomItem.roomIdentifier;

         var query = {
            searchUuid: this.$store.state.hotel.searchUuid,
            hotelId: this.hotelId,
            rooms: this.$store.state.hotel.selectedRooms,
            recommended: this.isRecommendedHotelRoom,
         };
         self.handlerClickedRoomIndex(roomGroupIndex);

         hotelService.hotelSelect(query).then((response) => {
            console.log("hotelSelect isteği atıldı");
            if (!response.result.success) {
               Popup.result(response.result);
               return;
            } else {
               self.basketResponse = {
                  hotelCode: response.hotelId,
                  basketUuid: response.basketUuid,
                  id: response.id,
                  rooms: response.rooms,
                  totalPrice: response.totalPrice.total,
                  totalPriceCurrency: this.$options.filters.currency(response.totalPrice.currency),
                  uuid: response.uuid,
                  checkoutEnabled: response.checkoutEnabled,
                  recommended: response.recommended,
                  channelId: Object.keys(response.rooms).length === 0 ? 0 : response.channelId,
                  boardId: Object.keys(response.rooms).length === 0 ? 0 : response.boardId,
                  packageCode: Object.keys(response.rooms).length === 0 ? null : response.packageCode,
                  roomGroupCode: response.roomGroupCode,
                  hotelName: response.hotelName,
                  boardName: response.board,
                  hotelStar: response.hotelStar,
               };
               self.$store.commit("hotel/updateBasketResponse", self.basketResponse);
            }
            self.$store.commit("app/setIsProgressGifActive", false);
         });
      },
      handlerShowRoomDetailModal() {
         this.$refs.uiModal.isModalOpen = !this.$refs.uiModal.isModalOpen;
      },
      setHotelVisibility() {
         var self = this;
         if (self.roomTypeFilter.length && self.roomTypeFilter.includes(self.room.board)) {
            self.isVisible = true;
         } else if (!self.roomTypeFilter.length) {
            self.isVisible = true;
         } else {
            self.isVisible = false;
         }
      },
      handlerRoomTypeFilter(roomTypes) {
         const self = this;
         self.roomTypeFilter = roomTypes.reduce
            ? roomTypes.reduce((acc, curr) => {
                 if (curr.checked === true) {
                    acc.push(curr.name);
                 }
                 return acc;
              }, [])
            : [];
         self.setHotelVisibility();
      },
   },
   watch: {
      isDynamicPackage: function (newValue) {
         var self = this;
         self.dynamicPackage = newValue;
      },
      roomDetailRadioNativeValue(newValue) {
         if (newValue == this.roomDetailRadioValueNonRefundable) {
            this.detailRoomPrice -= this.priceDiff;
            this.discountedRoomPrice = this.room.price.originalAmount;
         } else {
            this.discountedRoomPrice = this.roomDetailSearch.roomOptions[0].price.originalAmount;
            this.detailRoomPrice += this.priceDiff;
         }
      },
      room: {
         handler: function (newRoom) {
            const self = this;
            var basketResponse = self.$store.state.hotel.basketResponse;
            if (newRoom.roomGroupCode == basketResponse.roomGroupCode) {
               self.isVisible = true;
            } else {
               self.isVisible = false;
            }
         },
         deep: true,
      },
      "$store.state.hotel.basketResponse"(basketResponse) {
         this.isVisible = true;
         this.isSelectedItem = false;
         if (basketResponse.hotelCode == this.hotelId) {
            for (const [groupId, room] of Object.entries(basketResponse.rooms)) {
               if (room.roomIdentifier == this.room.roomIdentifier && groupId == this.roomGroupIndex) {
                  this.isSelectedItem = true;
               }
               if (this.room.roomGroupCode == basketResponse.roomGroupCode) {
                  this.isVisible = true;
               } else {
                  this.isVisible = false;
               }
            }
         }
      },
      "$store.state.hotel.hotelFilter.boardTypes": {
         handler: function (boardTypes) {
            const self = this;
            self.handlerRoomTypeFilter(Object.values(JSON.parse(JSON.stringify(boardTypes))));
         },
         immediate: true,
         deep: true,
      },
   },
   computed: {
      dynamicCssVariable() {
         var self = this;
         //Changing roomCard's ::before color based on provider.
         let providerColor = null;
         // paximum , expedia , meetingpoint, newprovider
         let colors = ["#FFC859", "#CF8CFF", "#59E3FF", "#6dd33e"];
         let channelsArr = listify(self.channels, (key, value) => ({ providerIndex: Number(key), ...value })).sort((a, b) => a.providerIndex - b.providerIndex);
         let roomProviderName = self.channels[self.roomDetail.channelId].providerName;
         if (self.isOnUsContract && !self.isOnUs) providerColor = "#ff598b";
         else if (self.isOnUsContract) providerColor = "#63A5F8";
         else {
            let providerIndex = channelsArr.findIndex((channel) => channel.providerName == roomProviderName);
            providerColor = colors[providerIndex % colors.length];
         }
         const isDarkTheme = document.documentElement.classList.contains("dark-theme");

         return {
            "--room-border-color": self.dynamicPackage ? "#88fff3" : isDarkTheme ? "#4A5568" : "#DFE3E6",
            "--room-bg-color": self.dynamicPackage ? "#d8fffb" : isDarkTheme ? "#2D3748" : "#f6f7f9",
            "--provider-color": providerColor,
         };
      },
      isRefundTypeBadgeVisible() {
         // 1: Refunable, 2:NonRefundable
         var self = this;
         return self.room.refundType == 1 || self.room.refundType == 2 ? true : false;
      },
   },
};
</script>

<style lang="scss" scoped>
#room-card-info {
   display: flex;
   flex-direction: column;
}
.room-card-wrapper {
   background-color: var(--room-bg-color);
   border: 1px solid var(--room-border-color);
   border-radius: 8px;

   &.active {
      background-color: var(--blue-100);
      border: 3px solid var(--blue-400);
   }

   .room-card-inner {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;

      &::before {
         content: "";
         position: absolute;
         width: 8px;
         height: 75%;
         left: 0;
         background-color: var(--provider-color);
         border-top-right-radius: 12px;
         border-bottom-right-radius: 12px;
         cursor: pointer;
      }

      // &::after {
      //    content: "Provider";
      //    position: absolute;
      //    left: 12px;
      //    background-color: rgba(0, 0, 0, 0.8);
      //    color: white;
      //    padding: 4px 8px;
      //    border-radius: 4px;
      //    font-size: 12px;
      //    white-space: nowrap;
      //    opacity: 0;
      //    pointer-events: none;
      //    transition: opacity 0.2s;
      //    z-index: 1000;
      // }

      // &:hover::after {
      //    opacity: 1;
      // }

      &.hide-provider-tooltip::after {
         display: none;
      }

      .room-card-inner-item {
         &.room-card-thumbnail {
            width: 15%;
            max-width: 15%;
            padding: 8px;
            margin-right: 16px;

            img {
               width: 100%;
               border: 1px solid var(--gray-500);
               border-radius: 8px;
               object-fit: cover;
            }
         }
         &.room-card-content {
            width: 100%;
            display: flex;

            @media (max-width: 576px) {
               // background-color: red !important;
               flex-direction: column;

               .room-card-content-item {
                  scale: 1 !important;
                  width: 100% !important;
                  max-width: 100% !important;
                  // border: 1px solid red;
                  align-items: flex-start !important;
                  padding-left: 32px !important;

                  &.room-card-price {
                     font-size: 1.5rem !important;

                     .room-price {
                        transform-origin: left;
                        scale: 1.2 !important;
                     }
                  }
               }

               .gts-flag.invisible {
                  display: none;
               }
            }

            .room-card-content-item {
               width: 15%;
               display: flex;
               flex-direction: column;
               justify-content: center;

               .room-see-details {
                  margin-top: 1rem;
               }

               &.room-card-name,
               &.room-card-name-no-image {
                  .provider-badge {
                     z-index: 9;
                     position: absolute;
                     right: 152px;
                     top: -1rem;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     min-width: 65px;
                     height: 28px;
                     padding: 0 0.75rem;
                     color: var(--gray-0);
                     background-color: var(--orange-400);
                     border-radius: 0 0 8px 8px;
                     font-size: var(--small);
                     font-weight: 600;
                     width: fit-content;

                     @media (max-width: 576px) {
                        scale: 0.8;
                        right: 0 !important;
                        top: -30px;
                     }
                  }
               }

               &.room-card-image {
                  max-width: 100px;
                  display: flex;
                  flex-direction: column;
                  margin-left: 2rem;
                  .with-image {
                     border-radius: 0.5rem;
                     min-width: 110px;
                     height: 85px;
                  }
                  .no-image {
                     border-radius: 0.5rem;
                     max-width: 100px;
                     height: 90px;
                  }
               }
               &.room-card-name {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  margin-top: 1rem;
                  width: 100%;
                  padding-left: 32px;
                  margin-bottom: 6px;
                  position: relative;

                  .partial-payment {
                     position: absolute;
                     display: flex;
                     flex-direction: column;
                     margin-right: 1rem;
                     scale: 0.7;
                     transform-origin: top;
                     right: 180px !important;
                     top: -16px !important;

                     .partial-payment-icon-container {
                        display: flex;
                        justify-content: center;
                        z-index: 5;

                        @media (max-width: 576px) {
                           display: none;
                        }

                        #partial-payment-icon {
                           height: 75px !important;
                           width: 75px !important;
                        }
                     }

                     .partial-payment-text {
                        margin-top: -0.75rem;
                        display: flex;
                        height: 32px;
                        //color: var(--gray-50);
                        color: var(--gray-0);
                        background: var(--cyan-500) !important;
                        border-radius: 1rem;
                        width: 140px;

                        @media (max-width: 576px) {
                           position: absolute;
                           left: -29px;
                           top: 150px;
                        }

                        span {
                           font-family: "Roboto", sans-serif;
                           font-weight: 400;
                           font-size: 15px;
                           margin: 0 auto;
                           margin-top: 4px;
                           height: 32px;
                           //color: var(--gray-50);
                           color: var(--gray-0);
                        }
                     }
                  }

                  .gts-flag {
                     @media (max-width: 576px) {
                        scale: 0.8;
                        right: 0 !important;
                        top: -30px;
                     }
                     position: absolute;
                     right: 152px;
                     top: -1.5rem;
                     width: 65px;
                     height: 84px;
                     background-image: url("data:image/svg+xml;base64,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");
                  }
                  .refund-badge-wrapper {
                     position: absolute;
                     max-width: 68px;
                     right: 56px;
                     top: 14px;
                     @media (max-width: 576px) {
                        right: 0.5rem;
                        top: 5rem;
                        max-width: 80px;
                     }
                     @media (min-width: 800px) and (max-width: 990px) {
                        right: 41px;
                        top: 82px;
                     }
                  }

                  h4 {
                     margin-bottom: 4px;
                     font-size: 16px;
                     font-weight: 600;
                     color: var(--gray-700);
                  }

                  p {
                     margin: 0;
                     padding: 0;
                     font-size: 12px;
                     color: var(--gray-500);
                  }
               }
               &.room-card-name-no-image {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  margin-top: 1rem;
                  width: 115%;
                  padding-left: 32px;
                  margin-bottom: 6px;
                  position: relative;

                  .partial-payment {
                     position: absolute;
                     display: flex;
                     flex-direction: column;
                     margin-right: 1rem;
                     scale: 0.7;
                     transform-origin: top;
                     right: 180px !important;
                     top: -16px !important;

                     .partial-payment-icon-container {
                        display: flex;
                        justify-content: center;
                        z-index: 5;

                        @media (max-width: 576px) {
                           display: none;
                        }

                        #partial-payment-icon {
                           height: 75px !important;
                           width: 75px !important;
                        }
                     }

                     .partial-payment-text {
                        margin-top: -0.75rem;
                        display: flex;
                        height: 32px;
                        //color: var(--gray-50);
                        color: var(--gray-0);
                        background: var(--cyan-500) !important;
                        border-radius: 1rem;
                        width: 140px;

                        @media (max-width: 576px) {
                           position: absolute;
                           left: -29px;
                           top: 150px;
                        }

                        span {
                           font-family: "Roboto", sans-serif;
                           font-weight: 400;
                           font-size: 15px;
                           margin: 0 auto;
                           margin-top: 4px;
                           height: 32px;
                           //color: var(--gray-50);
                           color: var(--gray-0);
                        }
                     }
                  }

                  .gts-flag {
                     @media (max-width: 576px) {
                        scale: 0.8;
                        right: 0 !important;
                        top: -30px;
                     }
                     position: absolute;
                     right: 152px;
                     top: -1.5rem;
                     width: 65px;
                     height: 84px;
                     background-image: url("data:image/svg+xml;base64,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");
                  }
                  .refund-badge-wrapper {
                     position: absolute;
                     max-width: 68px;
                     right: 56px;
                     top: 14px;
                     @media (max-width: 576px) {
                        right: 41px;
                        top: 82px;
                     }
                     @media (min-width: 800px) and (max-width: 990px) {
                        right: 52px;
                        top: 64px;
                     }
                  }

                  h4 {
                     margin-bottom: 4px;
                     font-size: 16px;
                     font-weight: 600;
                     color: var(--gray-700);
                  }

                  p {
                     margin: 0;
                     padding: 0;
                     font-size: 12px;
                     color: var(--gray-500);
                  }
               }

               &.room-card-price {
                  min-width: 15%;

                  align-items: flex-end;
                  padding-right: 1rem;
                  border-left: 1px solid var(--gray-200);
                  @media (max-width: 576px) {
                     width: 50%;
                  }

                  .room-price {
                     font-size: 1.25rem;
                     font-weight: 600;
                     color: var(--blue-700);

                     @media (max-width: 576px) {
                        scale: 0.8;
                     }

                     & > span.currency {
                        margin-left: 8px;
                     }
                     &.discount {
                        margin-top: 0.25rem;
                        font-size: 0.75rem;
                        margin-right: 1.5rem;
                        text-decoration: line-through;
                        color: var(--red-600);
                     }
                     &.discounted {
                        color: var(--teal-600);
                     }
                  }
               }
               &.room-card-pax-cta {
                  max-width: 8%;
                  min-width: max-content;
                  justify-content: center;
                  align-items: center;
                  border-left: 1px solid var(--gray-200);
                  border-radius: 0 8px 8px 0;

                  i {
                     cursor: pointer;
                     transition: all 0.05s ease-in-out;
                     &:hover {
                        transform: scale(1.25);
                     }
                  }

                  i.icon-error {
                     width: 24px !important;
                     height: 24px !important;
                  }

                  @media (max-width: 576px) {
                     scale: 0.7;
                     margin-bottom: 1rem;
                     &::v-deep button {
                        // background-color: var(--accent-primary);
                        margin: 0 0.5rem;
                        width: 8px !important;
                        height: 8px !important;

                        i.icon-error {
                           width: 16px !important;
                           height: 16px !important;
                           filter: brightness(100);
                        }
                     }
                  }

                  &::v-deep button {
                     background-color: var(--accent-primary);

                     i.icon-error {
                        width: 16px !important;
                        height: 16px !important;
                        filter: brightness(100) !important;
                     }
                  }

                  &.selected-item {
                     &::v-deep button {
                        background-color: var(--primary);
                     }
                  }
               }
               &.room-restrictions {
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  margin-right: 1rem;
                  width: 332px;
                  i {
                     display: flex;
                     background-repeat: no-repeat;
                     background-position: center center;
                     background-size: cover;
                     background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICA8ZyBpZD0iR3JvdXBfMTE2MzMiIGRhdGEtbmFtZT0iR3JvdXAgMTE2MzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTI0IC05NDQpIj4KICAgIDxnIGlkPSJHcm91cF8xMTYxMCIgZGF0YS1uYW1lPSJHcm91cCAxMTYxMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUzNy42MyA5NTEuNDA5KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzEwMzMzIiBkYXRhLW5hbWU9IlBhdGggMTAzMzMiIGQ9Ik0xOS40LDE0LjgyM2wtNC41LjU2NC0uMTYxLjc0Ny44ODQuMTYzYy41NzguMTM4LjY5Mi4zNDYuNTY2LjkyMmwtMS40NTEsNi44MTljLS4zODEsMS43NjMuMjA2LDIuNTk0LDEuNTg5LDIuNTk0YTQuMDcyLDQuMDcyLDAsMCwwLDIuODgtMS4xNzVsLjE3My0uODE4YTIuMTc4LDIuMTc4LDAsMCwxLTEuMzQ5LjQ4M2MtLjU0MSwwLS43MzgtLjM3OS0uNi0xLjA0OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNC42MjcgLTguNzUxKSIgZmlsbD0iIzNjNjdiMiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMDMzNCIgZGF0YS1uYW1lPSJQYXRoIDEwMzM0IiBkPSJNMTkuNjgyLDkuODQxYTEuOTY2LDEuOTY2LDAsMSwxLTEuOTY2LTEuOTY2QTEuOTY2LDEuOTY2LDAsMCwxLDE5LjY4Miw5Ljg0MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNC43NjUgLTcuODc1KSIgZmlsbD0iIzNjNjdiMiIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9IkVsbGlwc2VfMTMxNSIgZGF0YS1uYW1lPSJFbGxpcHNlIDEzMTUiIGQ9Ik0xNiwxLjhBMTQuMiwxNC4yLDAsMCwwLDUuOTU5LDI2LjA0MSwxNC4yLDE0LjIsMCwwLDAsMjYuMDQxLDUuOTU5LDE0LjEwNywxNC4xMDcsMCwwLDAsMTYsMS44TTE2LDBBMTYsMTYsMCwxLDEsMCwxNiwxNiwxNiwwLDAsMSwxNiwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUyNCA5NDQpIiBmaWxsPSIjM2M2N2IyIi8+CiAgPC9nPgo8L3N2Zz4K");
                     width: 38px;
                     height: 38px;
                  }
                  span.restrictions-info-txt {
                     padding-top: 1rem;
                     color: var(--primary);
                     font-weight: 500;
                     text-align: center;
                     line-height: 1.15rem;
                     font-size: 15px;
                  }
               }
               &.take-me-to-search {
                  margin-right: 1.5rem;
                  display: flex;
                  align-items: center;
                  .Available-calendar {
                     position: fixed;
                     bottom: 0;
                     right: 0;
                     transform: translate(-100%, -30%);
                     z-index: 1000;
                  }

                  button {
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     white-space: nowrap;
                     background-color: var(--accent-primary);
                     //color: var(--gray-50);
                     color: var(--gray-0);
                     font-weight: 700;
                     padding: 0rem 1rem;
                     border-radius: 0.5rem;
                     font-size: var(--small);
                     height: 48px;
                     width: fit-content;

                     &:hover {
                        background-color: var(--primary);
                     }

                     i {
                        width: 27px !important;
                        height: 27px !important;
                        margin-right: 0.5rem;
                     }
                     &.isClicked {
                        background-color: var(--orange-400);
                     }
                  }
                  span {
                     padding-top: 0.5rem;
                     color: var(--primary);
                     font-weight: 500;
                     text-align: center;
                     line-height: 1.15rem;
                     font-size: var(--small);
                     width: 200px;
                  }
               }
            }
         }
      }
   }
}

::v-deep .gts-modal-wrapper {
   .room-detail-section {
      .section-title {
         h4 {
            font-size: 14px;
            font-weight: 900;
         }
      }
   }
   .room-detail-section.room-slider {
      margin-bottom: 24px;
   }
   .room-detail-section.room-description {
      .section-content {
         p {
            font-size: 14px;
         }
      }
   }
}
.detail-modal-wrapper {
   margin-top: -2rem;
   .add-on-price-room-detail-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 3rem;
      margin-top: 1rem;
      span {
         text-align: right;
         background-color: var(--purple-100);
         color: var(--purple-400) !important;
         display: inline-block;
         width: fit-content;
         padding: 0 0.25rem;
         margin: 0 !important;

         &.add-on-label {
            margin-bottom: 0.25rem !important;
         }

         &.add-on-price {
            font-size: 1.25rem;
            font-weight: 900;
         }
      }
   }
   .buttons {
      margin-top: 1.25rem;
      margin-right: 1rem;
      display: flex;
      justify-content: flex-end;
   }
   .inner-buttons {
      padding-right: 0.75rem;
   }
   .room-detail-price {
      display: flex;
      flex-direction: column;
      margin-left: 3rem;
      margin-top: 0.5rem;
      padding-bottom: 1rem;
      .room-detail-total {
         margin-left: 0;
         margin-top: 0.5rem;
      }
      .room-discounted-price {
         font-size: 14px;
         color: var(--gray-800);
         font-weight: 600;
         text-decoration: line-through;
      }
      .room-price {
         font-size: 26px;
         color: var(--gray-800);
         font-weight: 800;
      }
      .room-price-detail {
         p {
            font-size: 13px;
         }
      }
   }
   .room-informations {
      width: 580px;
      display: flex;
      flex-direction: column;
      margin-top: 2rem;
      border-radius: 8px;
      opacity: 1;
      border: 1px solid var(--gray-200);
      height: 8rem;
      span {
         font-size: 16px;
         margin-left: 1rem;
         margin-top: 1rem;
         font-weight: 600;
      }
      p {
         color: var(--gray-700);
         opacity: 1;
         font-size: 12px;
         padding: 1rem;
      }
   }
   .room-options {
      width: 580px;
      display: flex;
      flex-direction: column;
      margin-top: 4rem;
      border-radius: 8px;
      opacity: 1;
      border: 1px solid var(--gray-200);

      span {
         font-size: 16px;
         margin-left: 1rem;
         margin-top: 1rem;
         font-weight: 500;
         color: var(--gray-800);
      }
      .room-options-radio {
         margin-left: 1rem;
         margin-top: 1rem;
      }
      .ref-nonref-radio {
         padding-bottom: 0.5rem;
      }
   }
   .facilites {
      margin-left: 1rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
   }
   .facility-header {
      display: flex;
      span {
         margin-top: 7px;
      }
      img {
         width: 30px;
      }
   }
   .facility-details {
      margin-top: 0.5rem;
      margin-left: 3rem;
   }
   .room-features {
      margin-top: 2rem;
      span {
         font: Roboto;
         font-size: 16px;
         margin-left: 1rem;
         font-weight: 700;
      }
      p {
         font: normal normal normal 12px/16px Roboto;
         font-weight: 500;
      }

      .room-facilites {
         width: 45%;
         margin-top: 1rem;
      }
   }
   .room-informations-features {
      background: var(--gray-50);
      width: 580px;
      display: flex;
      flex-direction: column;
      margin-top: 1rem;
      border-radius: 8px;
      opacity: 1;
      border: 1px solid var(--gray-200);
      height: 7rem;
      span {
         font-size: 16px;
         margin-left: 1rem;
         margin-top: 1rem;
         font-weight: 600;
      }
      p {
         color: var(--gray-700);
         opacity: 1;
         font-size: 12px;
         padding: 1rem;
         font-weight: 500;
      }
      .facility-highligted {
         display: flex;
         justify-content: space-between;
         align-items: center;
         padding: 1rem;
         img {
            margin-bottom: -8px;
            margin-right: 8px;
            width: 25px;
            height: 25px;
         }
         span {
            font-size: 13px;
            font-weight: 500;
            word-wrap: none;
            margin-left: 0;
            margin-top: 0.25rem;
         }
      }
   }
   .modal-header {
      margin-top: 2rem;
      margin-left: -1rem;
      border-bottom: none;
      span {
         font-size: 18px;
         font-weight: 600;
      }
      p {
         font-size: 12px;
      }
      .partial-payment {
         position: absolute;
         display: flex;
         flex-direction: column;
         margin-right: 1rem;
         scale: 0.6;
         transform-origin: top;
         left: 28rem;

         .partial-payment-icon-container {
            display: flex;
            justify-content: center;
            z-index: 5;

            @media (max-width: 576px) {
               display: none;
            }

            #partial-payment-icon {
               height: 75px !important;
               width: 75px !important;
            }
         }

         .partial-payment-text {
            margin-top: -0.75rem;
            display: flex;
            height: 32px;
            //color: var(--gray-50);
            color: var(--gray-0);
            background: var(--cyan-500) !important;
            border-radius: 1rem;
            width: 140px;

            @media (max-width: 576px) {
               position: absolute;
               left: -29px;
               top: 150px;
            }

            span {
               font-family: "Roboto", sans-serif;
               font-weight: 400;
               font-size: 15px;
               margin: 0 auto;
               margin-top: 4px;
               height: 32px;
               //color: var(--gray-50);
               color: var(--gray-0);
            }
         }
      }
   }
   .gts-flag {
      z-index: 9;
      position: absolute;
      right: 40px;
      margin-top: -1.44rem;
      width: 65px;
      height: 84px;
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NS42NCIgaGVpZ2h0PSI4NC4zMzUiIHZpZXdCb3g9IjAgMCA2NS42NCA4NC4zMzUiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjcxLjE4IC0xMDU2KSI+PHBhdGggZD0iTTAtOEg0OC4xMTVWNi4zMzhsLS4xMTUsNzBMMjQsNTkuNjUxLDAsNzYuMzM1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI4MCAxMDY0KSIgZmlsbD0iIzNjNjdiMiIvPjxwYXRoIGQ9Ik0tNi4zMjctMS4yNThBMy41NiwzLjU2LDAsMCwxLTcuODkyLS4yMjlhNi41NTYsNi41NTYsMCwwLDEtMi4yNDIuMzY2QTQuNDQyLDQuNDQyLDAsMCwxLTEyLjQtLjQyN2EzLjc2MiwzLjc2MiwwLDAsMS0xLjUtMS42MzcsNS43NjIsNS43NjIsMCwwLDEtLjU0My0yLjUyMnYtLjY3N2E2LjExOSw2LjExOSwwLDAsMSwuNS0yLjU4MUEzLjcxNywzLjcxNywwLDAsMS0xMi41LTkuNTEyYTQuMTc0LDQuMTc0LDAsMCwxLDIuMjE4LS41NzgsNC4xNTcsNC4xNTcsMCwwLDEsMi43NjkuODQ0QTMuNjA4LDMuNjA4LDAsMCwxLTYuMzI3LTYuNzg4aC0yYTEuOTg1LDEuOTg1LDAsMCwwLS42LTEuMjUxLDEuOTMyLDEuOTMyLDAsMCwwLTEuMjg5LS40LDEuODE4LDEuODE4LDAsMCwwLTEuNTkzLjc4Niw0LjEzNCw0LjEzNCwwLDAsMC0uNTU0LDIuMzM4di42MzZhMy45MzUsMy45MzUsMCwwLDAsLjU5NSwyLjM2NSwyLjAzNywyLjAzNywwLDAsMCwxLjc0My44QTIuMjc1LDIuMjc1LDAsMCwwLTguMzc3LTJWLTMuNzE5aC0xLjg2NlYtNS4yMjloMy45MTdaTTIuODI3LTguMjkySC0uMjIyVjBILTIuMjczVi04LjI5MkgtNS4yODFWLTkuOTUzSDIuODI3Wk05LjA0Ny0yLjYxMWExLjA1MiwxLjA1MiwwLDAsMC0uNDEtLjg5MkE1LjM4LDUuMzgsMCwwLDAsNy4xNjEtNC4xNmExMC40NjcsMTAuNDY3LDAsMCwxLTEuNjg4LS42OCwyLjc1OSwyLjc1OSwwLDAsMS0xLjctMi40NjgsMi40LDIuNCwwLDAsMSwuNDU1LTEuNDM5LDIuOTY1LDIuOTY1LDAsMCwxLDEuMzA2LS45ODgsNC45MTQsNC45MTQsMCwwLDEsMS45MTEtLjM1NSw0LjQ3Myw0LjQ3MywwLDAsMSwxLjkuMzg2LDMuMDI2LDMuMDI2LDAsMCwxLDEuMywxLjA5LDIuODUzLDIuODUzLDAsMCwxLC40NjEsMS42SDkuMDU0YTEuMzQyLDEuMzQyLDAsMCwwLS40MzEtMS4wNjMsMS43NywxLjc3LDAsMCwwLTEuMjEtLjM3OSwxLjg5MSwxLjg5MSwwLDAsMC0xLjE2OS4zMTgsMSwxLDAsMCwwLS40MTcuODM3Ljk2Ljk2LDAsMCwwLC40ODkuODEzLDUuNTIyLDUuNTIyLDAsMCwwLDEuNDM5LjYxNSw2LjIxNyw2LjIxNywwLDAsMSwyLjU1LDEuMzA2LDIuNiwyLjYsMCwwLDEsLjgsMS45NDFBMi40LDIuNCwwLDAsMSwxMC4xMjctLjYsNC4yNzksNC4yNzksMCwwLDEsNy41LjEzNyw1LjA4Miw1LjA4MiwwLDAsMSw1LjQtLjI4NCwzLjMxLDMuMzEsMCwwLDEsMy45NjUtMS40MzZhMi45NSwyLjk1LDAsMCwxLS41LTEuN0g1LjUyN3EwLDEuNjQ3LDEuOTY5LDEuNjQ3YTEuOTE1LDEuOTE1LDAsMCwwLDEuMTQyLS4zQS45NjcuOTY3LDAsMCwwLDkuMDQ3LTIuNjExWk0tMTMuMTkzLDcuNjA2YTQuMjkyLDQuMjkyLDAsMCwxLS4zNzEsMS44NDEsMi44LDIuOCwwLDAsMS0xLjA2MiwxLjIyMSwyLjkzOCwyLjkzOCwwLDAsMS0xLjU4NC40MywyLjk1OCwyLjk1OCwwLDAsMS0xLjU3Ny0uNDI1LDIuODIyLDIuODIyLDAsMCwxLTEuMDc0LTEuMjEzLDQuMTY5LDQuMTY5LDAsMCwxLS4zODYtMS44MTRWNy4yOTRhNC4yNjksNC4yNjksMCwwLDEsLjM3OC0xLjg0OEEyLjgxOCwyLjgxOCwwLDAsMS0xNy44LDQuMjJhMi45NDEsMi45NDEsMCwwLDEsMS41OC0uNDI3LDIuOTQxLDIuOTQxLDAsMCwxLDEuNTguNDI3LDIuODE4LDIuODE4LDAsMCwxLDEuMDY5LDEuMjI2LDQuMjU3LDQuMjU3LDAsMCwxLC4zNzgsMS44NDNabS0xLjQ4NC0uMzIyYTIuOTkyLDIuOTkyLDAsMCwwLS40LTEuN0ExLjMsMS4zLDAsMCwwLTE2LjIyMSw1YTEuMzA1LDEuMzA1LDAsMCwwLTEuMTM4LjU3NCwyLjk1OCwyLjk1OCwwLDAsMC0uNDA1LDEuNjgydi4zNDdhMy4wMjksMy4wMjksMCwwLDAsLjQsMS42ODksMS4zLDEuMywwLDAsMCwxLjE1Mi42LDEuMjksMS4yOSwwLDAsMCwxLjEzMy0uNTc5LDMuMDEyLDMuMDEyLDAsMCwwLC40LTEuNjg3Wm03LjIxMiwxLjEyM2EzLjE2OSwzLjE2OSwwLDAsMS0uNTU0LDEuOTU2LDEuNzc3LDEuNzc3LDAsMCwxLTEuNS43MzUsMS42NDYsMS42NDYsMCwwLDEtMS4yOTQtLjU1N3YyLjQ5aC0xLjQxMVY1LjcxN2gxLjMwOWwuMDQ5LjUxOGExLjY1OSwxLjY1OSwwLDAsMSwxLjMzOC0uNjE1LDEuNzg5LDEuNzg5LDAsMCwxLDEuNTE5LjcyMywzLjI1NCwzLjI1NCwwLDAsMSwuNTQyLDEuOTkyWm0tMS40MTEtLjFhMi4wNzksMi4wNzksMCwwLDAtLjI2MS0xLjEzOC44NTEuODUxLDAsMCwwLS43NTktLjQuOTI0LjkyNCwwLDAsMC0uOTEzLjUwOFY5LjQzOGEuOTQuOTQsMCwwLDAsLjkyMy41MjJRLTguODc3LDkuOTYtOC44NzcsOC4zWk0tNC4xNiwxMS4xYTIuNTk0LDIuNTk0LDAsMCwxLTEuODkyLS43MTMsMi41MzQsMi41MzQsMCwwLDEtLjczLTEuOVY4LjM0OWEzLjE5MiwzLjE5MiwwLDAsMSwuMzA4LTEuNDIzQTIuMjU4LDIuMjU4LDAsMCwxLTUuNiw1Ljk1OGEyLjQ0NiwyLjQ0NiwwLDAsMSwxLjI4Ny0uMzM5QTIuMTkzLDIuMTkzLDAsMCwxLTIuNjEsNi4zYTIuNzc4LDIuNzc4LDAsMCwxLC42MjMsMS45Mzh2LjU3NkgtNS4zNTJhMS4zMTEsMS4zMTEsMCwwLDAsLjQxMy44MywxLjI0NywxLjI0NywwLDAsMCwuODcyLjMxMywxLjUyMywxLjUyMywwLDAsMCwxLjI3NC0uNTkxbC42OTMuNzc2YTIuMTE4LDIuMTE4LDAsMCwxLS44NTkuN0EyLjgxOSwyLjgxOSwwLDAsMS00LjE2LDExLjFabS0uMTYxLTQuMzM2QS44ODQuODg0LDAsMCwwLTUsNy4wNDVhMS40NjMsMS40NjMsMCwwLDAtLjMzNC44MTFoMS45NjNWNy43NDNhMS4wNDMsMS4wNDMsMCwwLDAtLjI1NC0uNzI1QS45MTIuOTEyLDAsMCwwLTQuMzIxLDYuNzYyWm02LjEuMjc4QTMuODM0LDMuODM0LDAsMCwwLDEuMjc0LDdhMS4wMzQsMS4wMzQsMCwwLDAtMS4wNS41NDJWMTFILTEuMTg3VjUuNzE3SC4xNDZsLjAzOS42M2ExLjMwOCwxLjMwOCwwLDAsMSwxLjE3Ny0uNzI4LDEuNDc5LDEuNDc5LDAsMCwxLC40MzkuMDYzWk01LjM3NiwxMWExLjU2NywxLjU2NywwLDAsMS0uMTQyLS40NzRBMS43MDcsMS43MDcsMCwwLDEsMy45LDExLjFhMS44NzYsMS44NzYsMCwwLDEtMS4yODctLjQ0OUExLjQ0NSwxLjQ0NSwwLDAsMSwyLjEsOS41MTZhMS40OTMsMS40OTMsMCwwLDEsLjYyMy0xLjI4OSwzLjA3MiwzLjA3MiwwLDAsMSwxLjgtLjQ1NGguNjQ5di0uM2EuODcxLjg3MSwwLDAsMC0uMTg4LS41ODYuNzQuNzQsMCwwLDAtLjU5My0uMjIuODQxLjg0MSwwLDAsMC0uNTU5LjE3MS41ODEuNTgxLDAsMCwwLS4yLjQ2OUgyLjIyMmExLjQxNywxLjQxNywwLDAsMSwuMjgzLS44NSwxLjg3MiwxLjg3MiwwLDAsMSwuOC0uNjEzLDIuOTE4LDIuOTE4LDAsMCwxLDEuMTYyLS4yMjIsMi4zMDYsMi4zMDYsMCwwLDEsMS41NS40OTEsMS43MTcsMS43MTcsMCwwLDEsLjU3NCwxLjM3OXYyLjI5YTIuNTI2LDIuNTI2LDAsMCwwLC4yMSwxLjEzOFYxMVptLTEuMTY3LS45ODFhMS4yMTUsMS4yMTUsMCwwLDAsLjU3Ni0uMTM5LjkxNC45MTQsMCwwLDAsLjM5MS0uMzc0VjguNkg0LjY0OHEtMS4wNiwwLTEuMTI4LjczMmwwLC4wODNhLjU2NS41NjUsMCwwLDAsLjE4Ni40MzVBLjcyMS43MjEsMCwwLDAsNC4yMDksMTAuMDE5Wm01LjE1Ni01LjZ2MS4zaC45VjYuNzUyaC0uOVY5LjM4OWEuNjMuNjMsMCwwLDAsLjExMi40Mi41NjQuNTY0LDAsMCwwLC40My4xMjcsMi4yNSwyLjI1LDAsMCwwLC40MTUtLjAzNHYxLjA2OWEyLjksMi45LDAsMCwxLS44NTQuMTI3QTEuMzQ3LDEuMzQ3LDAsMCwxLDcuOTU0LDkuNlY2Ljc1Mkg3LjE4M1Y1LjcxN2guNzcxdi0xLjNaTTEwLjY4OCw4LjMxYTMuMTMzLDMuMTMzLDAsMCwxLC4zLTEuNCwyLjIxNiwyLjIxNiwwLDAsMSwuODcyLS45NTIsMi41NDMsMi41NDMsMCwwLDEsMS4zMjEtLjMzNywyLjQwNiwyLjQwNiwwLDAsMSwxLjc0Ni42NTQsMi42MjYsMi42MjYsMCwwLDEsLjc1NCwxLjc3N2wuMDEuMzYxYTIuNzYxLDIuNzYxLDAsMCwxLS42NzksMS45NTEsMi4zNTksMi4zNTksMCwwLDEtMS44MjEuNzM1LDIuMzcxLDIuMzcxLDAsMCwxLTEuODI0LS43MzIsMi44MSwyLjgxLDAsMCwxLS42ODEtMS45OTJabTEuNDExLjFhMS45NywxLjk3LDAsMCwwLC4yODMsMS4xNSwxLjAxOCwxLjAxOCwwLDAsMCwxLjYxMSwwLDIuMTU1LDIuMTU1LDAsMCwwLC4yODgtMS4yNTcsMS45NSwxLjk1LDAsMCwwLS4yODgtMS4xNDMuOTM3LjkzNywwLDAsMC0uODExLS40MDUuOTIyLjkyMiwwLDAsMC0uOC40QTIuMTkxLDIuMTkxLDAsMCwwLDEyLjEsOC40MTJaTTE5LjUzMSw3LjA0QTMuODM0LDMuODM0LDAsMCwwLDE5LjAyMyw3YTEuMDM0LDEuMDM0LDAsMCwwLTEuMDUuNTQyVjExSDE2LjU2M1Y1LjcxN0gxNy45bC4wMzkuNjNhMS4zMDgsMS4zMDgsMCwwLDEsMS4xNzctLjcyOCwxLjQ3OSwxLjQ3OSwwLDAsMSwuNDM5LjA2M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMDQgMTA5MykiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNLTc4Mi02MzQwbC04LjgyLDhILTc4MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA2MiA3Mzk2KSIgZmlsbD0iIzMwNGU4MSIvPjxwYXRoIGQ9Ik0tNzkwLjgyLTYzNDBsOC44Miw4aC04LjgyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTE4LjgyIDczOTYpIiBmaWxsPSIjMzA0ZTgxIi8+PC9nPjwvc3ZnPg==");

      @media (max-width: 576px) {
         right: 0;
         top: 0.5rem;
         margin-top: 0;
         scale: 0.7;
      }
   }
   .modal-hotel-room-image {
      display: flex;
      margin-top: 0.75rem;
      img {
         width: 580px;
         height: 300px;
         border-radius: 0.25rem;
      }
      .hotel-image-slide-box {
         display: flex;
         margin-top: 7.5rem;
         position: absolute;
         z-index: 1;
         background: white;
         width: 35px;
         height: 65px;
         justify-content: center;
         align-items: center;
         border-radius: 8px;
         cursor: pointer;
         &.left-arrow {
            margin-left: 3.5rem;
            left: 0;
         }

         &.right-arrow {
            margin-right: 3.25rem;
            right: 0;
         }
      }
      .hotel-image-slide-box:hover {
         transition: 0.3s;
         background: var(--gray-300);
      }
   }
   .modal-hotel-mini-images::-webkit-scrollbar {
      display: none;
   }
   .modal-hotel-mini-images {
      overflow-x: auto;
      overflow-y: hidden;
      cursor: pointer;
      display: flex;
      min-width: 90px;
      height: 60px;
      margin-top: 0.5rem;
      margin-left: -0.3rem;
      img {
         display: flex;
         width: 90px;
         height: 60px;
         border-radius: 0.5rem;
         border: 3px solid transparent;
         margin-left: 0.2rem;
      }
      .active-image {
         border: 3px solid yellow;
      }
   }
}
</style>
